import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 放单规则列表
export function releaseDocRuleList(params) {
  return request({
    url: URL.act.releaseDocRule.releaseDocRuleList,
    method: 'get',
    params
  })
}

// 放单规则-新增保存
export function saveReleaseDocRule(data) {
  return request({
    url: URL.act.releaseDocRule.saveReleaseDocRule,
    method: 'post',
    data
  })
}

// 放单规则-编辑保存
export function updateReleaseDocRule(data) {
  return request({
    url: URL.act.releaseDocRule.updateReleaseDocRule,
    method: 'put',
    data
  })
}

// 放单规则-列表删除
export function batchDelReleaseDocRule(data) {
  return request({
    url: URL.act.releaseDocRule.batchDelReleaseDocRule,
    method: 'delete',
    data
  })
}

// 组合放单
// 组合放单-新增保存
export function saveReleaseDocRuleGroup(data) {
  return request({
    url: URL.act.releaseDocRule.saveReleaseDocRuleGroup,
    method: 'post',
    data
  })
}

// 组合放单-编辑
export function updateReleaseDocRuleGroup(data) {
  return request({
    url: URL.act.releaseDocRule.updateReleaseDocRuleGroup,
    method: 'put',
    data
  })
}

// 组合放单-列表删除
export function batchDelReleaseDocRuleGroup(data) {
  return request({
    url: URL.act.releaseDocRule.batchDelReleaseDocRuleGroup,
    method: 'delete',
    data
  })
}

// 组合放单-列表
export function releaseDocRuleGroupList(data) {
  return request({
    url: URL.act.releaseDocRule.releaseDocRuleGroupList,
    method: 'post',
    data
  })
}

// 组合放单-编辑详情
export function releaseDocRuleGroupDetail(params) {
  return request({
    url: URL.act.releaseDocRule.releaseDocRuleGroupDetail,
    method: 'get',
    params
  })
}

// 放单组合列表-拖动更新排序
export function batchUpdateReleaseDocRuleGroup(data) {
  return request({
    url: URL.act.releaseDocRule.batchUpdateReleaseDocRuleGroup,
    method: 'put',
    data
  })
}
// 获取自动放单触发设置
export function queryAutomaticOrderReleaseSettings() {
  return request({
    url: URL.act.releaseDocRule.queryAutomaticOrderReleaseSettings,
    method: 'get'
  })
}
// 获取自动放单触发设置
export function saveReleaseDocConfig(data) {
  return request({
    url: URL.act.releaseDocConfig.saveReleaseDocConfig,
    method: 'post',
    data
  })
}
// 获取租户分公司触发配置
export function queryReleaseDocConfig(params) {
  return request({
    url: URL.act.releaseDocConfig.queryReleaseDocConfig,
    method: 'get',
    params
  })
}

// 放单保函设置-查询列表
export function queryReleaseGuaranteeList() {
  return request({
    url: URL.act.releaseGuarantee.queryReleaseGuarantee,
    method: 'post'
  })
}

// 放单保函设置-保存
export function saveReleaseGuarantee(data) {
  return request({
    url: URL.act.releaseGuarantee.saveReleaseGuarantee,
    method: 'post',
    data
  })
}

// 放单保函设置-移除
export function removeReleaseGuarantee(data) {
  return request({
    url: URL.act.releaseGuarantee.removeReleaseGuarantee,
    method: 'post',
    data
  })
}

